import { Pipe, PipeTransform } from '@angular/core'; 

@Pipe({
  name: 'calendarServiceHolyEucharistFilter'
})
export class CalendarServiceHolyEucharistFilterPipe implements PipeTransform {

  constructor() { }

  transform(services: any[]): any[] {
   
    var results = services.filter((service) => {return service.IsAvailableHolyEucharistService == true});

    return results;

  } 

}
